import styled, {css} from "styled-components";

const iconNormalStatePosY: string = "-150px";
const iconActiveStatePosY: string = "-200px";

interface IStickyNavigationMenuItemIconBoxProps {
  icon: string;
  isActive: boolean;
}

export const StickyNavigationMenuItemIconDefaultBox = styled.div<IStickyNavigationMenuItemIconBoxProps>`
  width: 2.4rem;
  height: 2.4rem;
  margin: 0.5rem;
  background-image: url(${props => props.theme.images.spriteSheet.toString()});
  background-repeat: no-repeat;

  ${props => {

    if (props.icon === "home") {

      if (props.isActive) return css`
        background-position: -340px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -340px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "slots") {

      if (props.isActive) return css`
        background-position: -484px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -484px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "casino-games") {

      if (props.isActive) return css`
        background-position: -562px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -562px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "live-casino") {

      if (props.isActive) return css`
        background-position: -411px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -411px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "jackpots") {

      if (props.isActive) return css`
        background-position: -734px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -734px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "exclusive888games") {

      if (props.isActive) return css`
        background-position: -814px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -814px ${iconNormalStatePosY};
      `;
    }


    if (props.icon === "promotions") {

      if (props.isActive) return css`
        background-position: -905px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -905px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "deposit") {
      return css`
        background-position: -648px ${iconNormalStatePosY};
      `;
    }

  }}
`;
